module.exports = __webpack_public_path__ + "img/DBDBBB_F7F7E4_AFAF89_C4C49C-256px.7d1fcb71.png";